const initialState = {
  notificationsEnabled: true,
};

const Actions = {
  USER_NOTIFICATIONS_CHANGED: 'user-notification-settings/setting-changed',
};

const notificationSettingsChanged = (enabled) => ({
  type: Actions.USER_NOTIFICATIONS_CHANGED,
  enabled,
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.USER_NOTIFICATIONS_CHANGED:
      return { ...state, notificationsEnabled: action.enabled };
  }

  return state;
};

const selectUserNotificationEnabled = (state) =>
  state.userNotificationsSettings.notificationsEnabled;

export { reducer, notificationSettingsChanged, selectUserNotificationEnabled };
